module.exports = __webpack_public_path__ + "img/solutionh-banner.a61ed301.png";